var _classCallCheck = require("G:\\Reacting\\about-me\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("G:\\Reacting\\about-me\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("G:\\Reacting\\about-me\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("G:\\Reacting\\about-me\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("G:\\Reacting\\about-me\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("G:\\Reacting\\about-me\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

module.exports =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(HttpError, _Error);

  function HttpError(message, code, headers) {
    var _this;

    _classCallCheck(this, HttpError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HttpError).call(this, message)); // Maintains proper stack trace (only available on V8)

    /* istanbul ignore next */

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    }

    _this.name = 'HttpError';
    _this.code = code;
    _this.headers = headers;
    return _this;
  }

  return HttpError;
}(_wrapNativeSuper(Error));